var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Sorry")]),_c('h3',[_vm._v("The page you are looking for cannot be found. Please "),_c('a',{attrs:{"href":("mailto:" + _vm.supportEmail)}},[_vm._v("contact us")]),_vm._v(" for assistance.")])])}
var staticRenderFns = []

export { render, staticRenderFns }